document.addEventListener("DOMContentLoaded", function() {
    const track = document.querySelector(".carousel-track");
    const items = document.querySelectorAll(".carousel-item");
    const prevBtn = document.querySelector(".carousel-btn.prev");
    const nextBtn = document.querySelector(".carousel-btn.next");

    if (!track || items.length === 0) return;

    let index = 0;
    let itemWidth = items[0].offsetWidth + 20; 
    let maxIndex = items.length - 2;

    function updateCarousel() {
        track.style.transform = `translateX(${-index * itemWidth}px)`;
    }

    nextBtn.addEventListener("click", () => {
        if (index < maxIndex) index++;
        updateCarousel();
    });

    prevBtn.addEventListener("click", () => {
        if (index > 0) index--;
        updateCarousel();
    });

    let startX = 0;
    let isMouseDown = false;
    let isDragging = false;
    let currentTranslate = 0;
    let prevTranslate = 0;
    let dragThreshold = 5; // px before we consider it a drag
    let startTranslate = 0;

    function setPosition(x) {
        track.style.transform = `translateX(${x}px)`;
    }

    function dragStart(x) {
        startX = x;
        isMouseDown = true;
        isDragging = false;                 // <-- don't mark as dragging yet
        startTranslate = prevTranslate;     // remember where we started

        track.classList.add("dragging");
        track.style.transition = "none";
    }

    function dragMove(x) {
        if (!isMouseDown) return;

        const delta = x - startX;

        // Only become a "real" drag after moving a bit
        if (!isDragging && Math.abs(delta) > dragThreshold) {
            isDragging = true;
            track.querySelectorAll("a").forEach(a => a.style.pointerEvents = "none");
        }

        if (!isDragging) return; // still just a click

        currentTranslate = startTranslate + delta;
        setPosition(currentTranslate);
    }

    function dragEnd() {
        // Always restore link clickability
        track.querySelectorAll("a").forEach(a => a.style.pointerEvents = "auto");

        if (!isMouseDown) return; // safety

        isMouseDown = false;
        track.classList.remove("dragging");

        // If we never actually dragged, don't snap – let it be a normal click
        if (!isDragging) {
            track.style.transition = ""; // optional: reset
            return;
        }

        isDragging = false;
        track.style.transition = "transform 0.4s ease";

        index = Math.round(Math.abs(currentTranslate) / itemWidth);
        if (index < 0) index = 0;
        if (index > maxIndex) index = maxIndex;

        prevTranslate = -index * itemWidth;
        setPosition(prevTranslate);
    }

    // Click events
    // track.addEventListener("click", function (e) {
    //     if (isDragging) {
    //         isMouseDown = true;
    //         e.preventDefault();
    //         e.stopPropagation();
    //         return false;
    //     }else{
    //         return true;
    //     }
    // });

    // Touch events
    track.addEventListener("touchstart", e => dragStart(e.touches[0].clientX));
    track.addEventListener("touchmove", e => dragMove(e.touches[0].clientX));
    track.addEventListener("touchend", dragEnd);

    // Mouse events
    track.addEventListener("mousedown", e => dragStart(e.clientX));
    track.addEventListener("mousemove", e => dragMove(e.clientX));
    track.addEventListener("mouseup", dragEnd);
    track.addEventListener("mouseleave", dragEnd);

    // Resize
    window.addEventListener("resize", () => {
        itemWidth = items[0].offsetWidth + 20;
        prevTranslate = -index * itemWidth;
        setPosition(prevTranslate);
    });

    updateCarousel();
});
